import React from "react";
import styled from "styled-components";
import { Row, Col } from "antd";

import { IState, IUpdateQuestionnaireFieldPayload } from "../questionnaire.interfaces";
import { SectionHeader } from "../section-header.component";
import { eyeHealthHistoryQuestions } from "../questions";
import { QuestionCheckbox } from "../inputs/question-checkbox.component";
import { FamilyQuestionAnswers } from "../../../../../../../patient-app/src/questionnaire/Questionnaire.interfaces";

interface IProps {
  updateQuestionnaireField: (value: IUpdateQuestionnaireFieldPayload) => void;
  eyeHealthHistory: IState["eyeHealthHistory"];
}

export const EyeHealthHistory = (props: IProps) => {
  const { eyeHealthHistory, updateQuestionnaireField } = props;
  return (
    <>
      <SectionHeader header="EYE HEALTH HISTORY" />
      <Row gutter={16}>
        <CenteredCol span={2} offset={12}>
          <Option>You</Option>
        </CenteredCol>
        <CenteredCol span={2}>
          <Option>Mother</Option>
        </CenteredCol>
        <CenteredCol span={2}>
          <Option>Father</Option>
        </CenteredCol>
        <CenteredCol span={2}>
          <Option>Sister</Option>
        </CenteredCol>
        <CenteredCol span={2}>
          <Option>Brother</Option>
        </CenteredCol>
        <CenteredCol span={2}>
          <Option>No / Unknown</Option>
        </CenteredCol>
      </Row>
      {eyeHealthHistoryQuestions.map((q, i) => (
        <QuestionCheckbox
          key={q.question}
          isRowOdd={!!(i & 1)}
          question={q.question}
          options={q.options}
          defaultValue={eyeHealthHistory[q.key]}
          onChange={(e: any) => {
            const { value } = e.target;
            let answers = eyeHealthHistory[q.key];
            const payload = {
              section: "eyeHealthHistory",
              key: q.key,
            };

            if (value === "no") {
              if (answers.includes("no" as FamilyQuestionAnswers)) {
                updateQuestionnaireField({
                  ...payload,
                  value: [],
                });
              } else {
                updateQuestionnaireField({
                  ...payload,
                  value: [value],
                });
              }
              return;
            } else {
              if (answers.includes("no" as FamilyQuestionAnswers)) {
                answers = answers.filter((answer) => answer !== "no");
                updateQuestionnaireField({
                  ...payload,
                  value: answers,
                });
              }
            }

            if (answers.includes(value)) {
              updateQuestionnaireField({
                ...payload,
                value: answers.filter((answer) => answer !== value),
              });
            } else {
              updateQuestionnaireField({
                ...payload,
                value: [...answers, value],
              });
            }
          }}
        />
      ))}
    </>
  );
};

const Option = styled.div`
  font-size: 13px;
  font-weight: bold;

  @media (max-width: 1100px) {
    font-size: 12px;
    writing-mode: vertical-rl;
  }
`;

const CenteredCol = styled(Col)`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;
